<template>
    <div>
        <v-card :elevation="0" class="v-sheet theme--light br-0">
            <v-card-title>
                <v-row class="col-md-12">
                    <v-col cols="12" sm="12" md="12">
                        Configuración de Boletas
                    </v-col>
                    
            
                </v-row>
                 <v-row class="col-md-12 pt-0 pb-0 mb-0">
                    <v-col cols="12" md="5" sm="5" xs="12" class="pt-0 pb-0 mb-0">
                        <v-select
                            v-model="datosItem.periodoMedicionId"
                            :items="periodos"
                            :loading="ddPeriodosLoading"
                            dense
                            outlined
                            label="Periodo de medición"
                            item-text="anioMedicion"
                            item-value="id"
                            :no-data-text="periodos!=null ? 'Selecciona un periodo' : 'No se han encontrado periodos'"
                            @change="establecido=false;"
                        ></v-select>
                    </v-col>

                    <v-col cols="12" md="7" sm="7" xs="12" class="pt-0 pb-0 mb-0">
                        <v-select
                            v-model="indiceSeleccionadoId"
                            :items="indices"
                            :loading="ddIndicesLoading"
                            :disabled="datosItem.periodoMedicionId<=0"
                            dense
                            outlined
                            label="Seleccionar Índice"
                            item-text="nombreIndice"
                            item-value="id"
                            :hint="datosItem.periodoMedicionId<=0 ? 'Debe seleccionar un periodo de medición' : ''"
                            :no-data-text="indices ? 'Selecciona un índice' : 'No se han registrado índices'"
                            @change="obtenerPreguntasPorIndiceParaAsignacion(); obtenerBoletasPorIndice(); establecido=false;"
                        ></v-select>
                    </v-col>
                </v-row>

                <v-row class="col-md-12 pt-0 mt-0">
                    <v-col cols="12" md="5" sm="5" xs="12" class="pt-0 mt-0 pb-1">
                        <v-select
                            v-model="datosItem.boletasId"
                            :items="boletas"
                            :loading="ddBoletasLoading"
                            dense
                            outlined
                            label="Seleccionar boleta"
                            item-text="descripcion"
                            item-value="id"
                            :no-data-text="indices.length<=0 ? 'No se ha seleccionado un índice' : 'El índice seleccionado no tiene boletas asignadas'"
                            @change="establecido=false;"
                        ></v-select>
                    </v-col>

                     <v-col cols="12" md="7" sm="7" xs="12" class="pt-0 mt-0 pb-1">
                        <v-btn
                            color="primary"
                            class="mb-2 float-right bg-light-blue"
                            @click="obtenerPreguntasPorIndice();"
                            :disabled="datosItem.boletasId<=0 || indiceSeleccionadoId<=0"
                        >
                            Establecer
                            <v-icon right>mdi-check</v-icon>
                        </v-btn>
                    </v-col> 

                    
                </v-row>

                <v-row v-if="establecido==false">
                    <v-col cols="12">
                        <v-alert
                            text
                            prominent
                            type="error"
                            icon="mdi-alert"
                            dense
                            small
                            >
                                <p class="mt-3">Para poder asignar preguntas, debes de establecer la configuración de periodo de medición, índice y boleta.</p> 
                            </v-alert>
                    </v-col>
                </v-row>

                <v-row class="col-md-12 m-0 p-0">
                    <v-divider></v-divider>
                </v-row>
            </v-card-title>

            
                        
            <v-card-text>
                <v-row>
                    <v-col cols="12" sm="4" md="4" xs="12">
                        <v-btn
                            color="primary"
                            class="mb-2 float-left bg-light-blue"
                            :disabled="establecido==false || boletas.length <=0"
                            @click="modalNueva"
                        >
                            <v-icon left>mdi-plus</v-icon>
                             Asignar pregunta
                        </v-btn>
                    </v-col> 

                    <v-col cols="12" md="8" sm="8" xs="12">
                        <v-text-field
                            outlined
                            autocomplete="off"
                            dense
                            v-model="tableFilter"
                            label="Buscar"
                            maxlength="100"
                        ></v-text-field>
                    </v-col>
                </v-row>


                <SubHeader subHeaderTitle="Preguntas Asignadas a la boleta " />
                
                
                <v-data-table
                        :headers="headers"
                        :items="preguntas"
                        item-key="Id"
                        class="elevation-0"
                        :loading="tableLoading"
                        no-data-text="No hay datos para mostrar"
                        :search="tableFilter"
                        :items-per-page="10"
                        :footer-props="{
                            showFirstLastPage: true,
                            firstIcon: 'mdi-page-first',
                            lastIcon: 'mdi-page-last',
                            prevIcon: 'mdi-chevron-left',
                            nextIcon: 'mdi-chevron-right',
                            'items-per-page-text':'Registros por página',
                            pageText: '{0}-{1} de {2}' 
                        }"
                        dense
                    >
                    <template v-slot:item="{ item }">
                        <tr>
                            <!--<td>{{ item.id }}</td>-->
                            <td>{{ item.noOrdenPregunta }}</td>
                            <td>{{ item.textoPregunta }}</td>
                            <td> 
                                <div v-for="(respuesta) in item.listaRespuestas" :key="'R' + respuesta.idRespuesta" class="border-bottom border-secondary mb-2">
                                    {{respuesta.textoRespuesta}}
                                </div>
                            </td>

                            <td> 
                                <div v-for="(medioverificacion) in item.listaMediosVerificacion" :key="medioverificacion.id" class="border-bottom border-secondary mb-2">
                                    {{medioverificacion.codigo != null ? `${medioverificacion.codigo} - ` : ''}}{{medioverificacion.nombre}}
                                </div>
                            </td>

                            <td>{{ item.visitaCampo }}</td>
                            
                            <td>
                                <v-chip
                                        class="ma-2"
                                        :color="item.estadoId === 1 ? 'teal' : 'orange' "
                                        text-color="white"
                                        small
                                    >
                                        {{item.estado}}
                                </v-chip>
                            </td>
                            <td>
                                <v-btn class="ma-2" small tile outlined color="indigo" @click="obtenerDatosItem(item.asignacionId, 1, null)">
                                    <v-icon left>mdi-pencil</v-icon> Actualizar
                                </v-btn>

                                <v-btn class="ma-2" small tile outlined color="indigo" @click="obtenerSubPreguntasPorPregunta(item.preguntaId, item.indicesId)" :disabled="establecido==false || boletas.length <=0">
                                    <v-icon left>mdi-plus</v-icon> Asignar Subpreguntas
                                </v-btn>

                                
                            </td>
                        </tr>
                        <!-- Subpreguntas -->

                        <tr div v-for="subpregunta in item.subPreguntaN1" :key="'S' + subpregunta.preguntaId">

                                <td></td>
                                <td>
                                    <v-row>
                                        <v-col md="1" sm="1" xs="1"></v-col>
                                        <v-col md="11" sm="11" xs="11">{{ item.noOrdenPregunta }}.{{ subpregunta.noOrdenPregunta }} {{ subpregunta.textoPregunta }} </v-col>
                                    </v-row>
                                </td>
                                <td> 
                                    <div v-for="(respuesta) in subpregunta.listaRespuestas" :key="'R1'+respuesta.idRespuesta" class="border-bottom border-secondary mb-2">
                                        {{respuesta.textoRespuesta}}
                                    </div>
                                </td>
                                <td></td>
                                <td>{{ item.visitaCampo }}</td>
                                <td>
                                    
                                    <v-chip
                                            class="ma-2"
                                            :color="subpregunta.estadoId === 1 ? 'teal' : 'orange' "
                                            text-color="white"
                                            small
                                        >
                                            {{subpregunta.estado}}
                                    </v-chip>
                                </td>
                                <td>
                                    <v-btn class="ma-2" small tile outlined color="indigo" @click="obtenerDatosItem(subpregunta.asignacionId, 2, subpregunta.preguntaIdFk)">
                                        <v-icon left>mdi-pencil</v-icon> Actualizar
                                    </v-btn>
                                </td>
                                

                            </tr>

                        </template>

                </v-data-table>
            </v-card-text>
        </v-card>




    <!-- Inicio:: Dialog para mostrar los datos de la pregunta-->
    <v-dialog
        v-model="dialog"
        max-width="800px" 
        persistent 
        transition="dialog-bottom-transition"
        
    >
        
        <v-card scrollable>
            <v-card-title>
                {{modalTitle}}
                
                <v-spacer></v-spacer>
                <v-btn
                    icon
                    :disabled="btnRegistroLoading"
                    @click="dialog = false; resetForm()"
                    class="float-right"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-form
                ref="form"
                v-on:submit.prevent="registrarItem"
                v-model="validForm"
                >
                <v-card-text>
                    <v-row>
                        <v-col cols="12" md="12" sm="12" xs="12" class="pt-1 pb-1">
                            <v-select
                                v-model="datosItem.periodoMedicionId"
                                :items="periodos"
                                :loading="ddPeriodosLoading"
                                dense
                                outlined
                                :disabled="true"
                                label="Periodo de medición"
                                item-text="anioMedicion"
                                item-value="id"
                                :no-data-text="periodos!=null ? 'Selecciona un periodo' : 'No se han encontrado periodos'"
                                :rules="[selectRequired('Periodo medición')]"
                            ></v-select>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="12" sm="12" xs="12" class="pt-1 pb-1">
                            <v-select
                                v-model="indiceSeleccionadoId"
                                :items="indices"
                                :loading="ddIndicesLoading"
                                dense
                                :disabled="true"
                                outlined
                                label="Índice seleccionado"
                                item-text="nombreIndice"
                                item-value="id"
                                :no-data-text="indices ? 'Selecciona un índice' : 'No se han registrado índices'"
                                :rules="[selectRequired('Índice')]"
                                @change="obtenerPreguntasPorIndice"
                            ></v-select>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" md="12" sm="12" xs="12" class="pt-0 mt-0 pb-1">
                            <v-select
                                v-model="datosItem.boletasId"
                                :items="boletas"
                                :loading="ddBoletasLoading"
                                dense
                                :disabled="true"
                                outlined
                                label="Boleta a asignar"
                                item-text="descripcion"
                                item-value="id"
                            ></v-select>
                        </v-col>
                
                    </v-row>

                    <v-row>
                        <v-col cols="12" md="12" sm="12" xs="12"  class="pt-1 pb-1">
                            <v-select
                                dense
                                :items="preguntasAsignar"
                                :disabled="accion===2"
                                item-text="textoPregunta"
                                item-value="id"
                                label="Seleccionar pregunta"
                                outlined
                                v-model="datosItem.preguntasId"
                            >

                            </v-select>
                        
                        </v-col>
                    </v-row>


                    <v-row>
                        <v-col cols="12" md="6" sm="6" xs="12"  class="pt-1 pb-1">
                            <v-text-field
                                dense
                                label="Número de orden para la pregunta"
                                outlined
                                v-model="datosItem.noOrdenPregunta"
                                :rules="[
                                    required('Número de orden'),
                                    onlyInteger('Número de orden'),
                                    maxLength('Número de orden', 3)
                                ]"
                                maxlength="3"
                                v-mask="'###'"
                            >

                            </v-text-field>
                        
                        </v-col>

                        <v-col cols="6" md="6" sm="6" xs="12" class="pt-1 pb-1">
                            <v-select
                                v-model="datosItem.visitaCampo"
                                :items="visitaCampoValores"
                                dense
                                outlined
                                class="required"
                                label="¿La pregunta estará sometida a visita de campo?"
                                item-text="visita"
                                item-value="id"
                                :rules="[
                                    selectRequired('Visita de campo')
                                ]"
                            ></v-select>
                        </v-col>
                    </v-row>
                    
                    <v-row>
                        <v-col  md="12" sm="12" class="pt-1 pb-1">
                             <label class="grey--text body-2">Estado</label>
                             <template>
                                <v-switch
                                    v-model="switchItemEstado"
                                    inset
                                    :label="switchItemEstado ? 'Activo' : 'Inactivo'"
                                    >
                                </v-switch>
                             </template>
                        </v-col>
                    </v-row>

                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                            <v-btn
                                color="grey lighten-5"
                                elevation="0"
                                class="mb-2 float-right grey lighten-5"
                                @click="dialog = false; resetForm()"
                                :disabled="btnRegistroLoading"
                            >
                                Cancelar
                            </v-btn>
                            <!--:disabled="!validDocForm" type="submit"-->
                            <v-btn
                                color="primary"
                                class="mb-2 float-right"
                                type="submit"
                                :elevation="0" 
                                :disabled="!validForm" 
                                :loading="btnRegistroLoading"                         
                            >
                                {{btnRegistroText}}
                            </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>


    <!-- Fin:: Dialog para mostrar los datos de la pregunta-->

    <!-- Inicio:: Dialog para mostrar las subpreguntas de la pregunta seleccionada-->
    <v-dialog
        v-model="dialogAsingarSub"
        max-width="800px" 
        persistent 
        transition="dialog-bottom-transition"
        
    >
        
        <v-card scrollable>
            <v-card-title>
                Asignar Subpreguntas
                <v-spacer></v-spacer>
                <v-btn
                    icon
                    :disabled="btnRegistroLoading"
                    @click="dialogAsingarSub=false; resetFormSub();"
                    class="float-right"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-form
                ref="form"
                v-on:submit.prevent="registrarItem"
                v-model="validForm2"
                >
                <v-card-text>
                    <v-row class="mt-2">
                        <v-col cols="12" md="12" sm="12" xs="12" class="pt-1 pb-1">
                            <v-select
                                v-model="datosItem.preguntasId"
                                :items="subpreguntas"
                                :loading="ddSubPreguntasLoading"
                                dense
                                :disabled="accion===2"
                                outlined
                                label="Seleccionar sub pregunta"
                                item-text="textoPregunta"
                                item-value="id"
                                :no-data-text="subpreguntas!=null ? 'Selecciona una sub pregunta' : 'No se han encontrado subpreguntas, verificar con un administrador'"
                                :rules="[selectRequired('Sub pregunta')]"
                            ></v-select>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" md="12" sm="12" xs="12"  class="pt-1 pb-1">
                            <v-text-field
                                dense
                                label="Número de orden para la sub pregunta"
                                outlined
                                v-model="datosItem.noOrdenPregunta"
                                :rules="[
                                    required('Número de orden'),
                                    onlyInteger('Número de orden'),
                                    maxLength('Número de orden', 3)
                                ]"
                                maxlength="3"
                                v-mask="'###'"
                            >

                            </v-text-field>
                        
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col  md="12" sm="12" class="pt-1 pb-1">
                             <label class="grey--text body-2">Estado</label>
                             <template>
                                <v-switch
                                    v-model="switchItemEstado"
                                    inset
                                    :label="switchItemEstado ? 'Activo' : 'Inactivo'"
                                    >
                                </v-switch>
                             </template>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                        <v-btn
                            color="grey lighten-5"
                            elevation="0"
                            class="mb-2 float-right grey lighten-5"
                            @click="dialogAsingarSub = false; resetFormSub()"
                            :disabled="btnRegistroSubLoading"
                        >
                            Cancelar
                        </v-btn>
                        <!--:disabled="!validDocForm" type="submit"-->
                        <v-btn
                            color="primary"
                            class="mb-2 float-right"
                            type="submit"
                            :elevation="0" 
                            :disabled="!validForm2" 
                            :loading="btnRegistroSubLoading"                         
                        >
                            Asignar Sub Pregunta
                        </v-btn>
                </v-card-actions>
            </v-form>

        </v-card>
    </v-dialog>
    <!-- Fin:: Dialog para mostrar las subpreguntas de la pregunta seleccionada-->

    <!--Dialog loader -->
    <dialog-loader
        :dialogVisible="dialogLoaderVisible"
        :text="dialogLoaderText"
    ></dialog-loader>
    <!---->

    <!--Inicio:: Snack alert-->
    <SnackAlert ref="snackalert"></SnackAlert>
    <!-- Fin:: Snack alert-->
    </div>
</template>
<script>
import Vue from 'vue';
import moment from "moment";

import validations from "@/core/untils/validations.js";
import SubHeader from "@/view/components/subheader/SubHeader";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { OBTENER_INDICES } from "@/core/services/store/catalogos/indice.module";
import { OBTENER_PERIODOS } from "@/core/services/store/catalogos/periodomedicion.module";
import { OBTENER_BOLETAS } from "@/core/services/store/boletas/boleta.module";
import {  OBTENER_PREGUNTAS_POR_INDICE } from "@/core/services/store/pregunta.module";

import {OBTENER_SUB_PREGUNTAS_POR_PREGUNTA} from "@/core/services/store/preguntas/subpregunta.module";

import {OBTENER_PREGUNTAS_PERIODO_BOLETA_CONFIGURACION, ASIGNAR_PREGUNTA_PERIODO_BOLETA, ACTUALIZAR_PREGUNTA_PERIODO_BOLETA, OBTENER_PREGUNTA_PERIODO_BOLETA} from "@/core/services/store/preguntasperiodoboleta/preguntaperiodoboleta.module";

import SnackAlert from '@/view/content/SnackAlert.vue';
import DialogLoader from "@/view/content/DialogLoader";

moment.locale('es');
Vue.filter("formatDate", function(value) {
    if (value) {
        return moment(String(value)).format("DD/MM/YYYY");
    }
});

export default {
    name: "ConfiguracionBoletas",
    components: {
        SnackAlert,
        SubHeader,
        DialogLoader
    },
    data() {
        return {
            tableLoading: false,
            ddPreguntasLoading:false,
            ddBoletasLoading:false,
            ddSubPreguntasLoading:false,
            tableFilter:'',
            validForm:false,
            validForm2: false,
            establecido:false,
            itemName: "Índices",
            dialog: false,
            dialogAsingarSub:false,
            modalTitle: 'Registrar Índice',
            btnRegistroLoading: false,
            btnRegistroSubLoading:false,
            dialogLoaderVisible: false,
            activePicker:null,
            menuFechaApertura: false,
            menuFechaCierre:false,
            fechas: {
                fechaApertura:'',
                fechaCierre: '',
            },
            dialogLoaderText: 'Obteniendo informacion....',
            btnRegistroText: 'Guardar',
            accion: 1,
            indices: [],
            indiceSeleccionadoId:0,
            preguntas: [],
            subpreguntas:[],
            subPreguntasAsignadas:[],
            subPreguntaSeleccionadaId:0,
            preguntasAsignar:[],
            boletas: [],
            ddIndicesLoading: false,
            ddPeriodosLoading: false,
            periodos: [],
            switchItemEstado: true,
            visitaCampoValores: [{id: 'SI', visita: 'Si'}, {id: 'NO', visita: 'No'}],
            datosItem: {
                id: 0,
                preguntasId:0,
                visitaCampo: 'No',
                noOrdenPregunta: "0",
                periodoMedicionId: 0,
                boletasId:0,
                estadosId: 1
            },
            ...validations
        } 
    }, 
    methods: {
        //!Definir la fecha máxima que se puede seleccionar en el datepicker
        maxDate() {
            const date = new Date();
            date.setFullYear(date.getFullYear() + 1);
            return date.toISOString().substr(0, 10);
        },

        //!Definir la fecha minima que se puede seleccionar en el datepicker
        minDate() {
            const date = new Date();
            date.setFullYear(date.getFullYear());
            return date.toISOString().substr(0, 10);
        },


        modalNueva(){
            this.accion =1;
            this.modalTitle='Asignar pregunta a boleta';
            this.btnRegistroText='Guardar';
            this.switchItemEstado=true;
            this.dialog=true;
        },

        resetForm(){
           // this.$refs.form.reset();
            let boletaSeleccionada = this.datosItem.boletasId;
             this.datosItem= {
                id: 0,
                preguntasId: 0,
                boletasId: boletaSeleccionada,
                noOrdenPregunta: "0",
                periodoMedicionId: this.datosItem.periodoMedicionId,
                indicesId: 0,
                estadosId: 1
            };
            this.accion=1;
            this.switchItemEstado = true;
            //console.log(this.switchItemEstado)
        },

        resetFormSub(){
            this.accion=1;

        },

        async obtenerIndices(){
            this.indices=[];
            this.ddIndicesLoading=true;
            await this.$store
            .dispatch(OBTENER_INDICES, 1)
            .then(res => {
                if(res.status===200){
                    this.indices=res.data;
                } else {
                    console.warn(res.message)
                }
                this.ddIndicesLoading=false;
               
            }
            )
            .catch(() => {
                this.ddIndicesLoading=false;
                //console.warn(err)
            });
        },


        //!Obtener boletas por indice seleccionado y periodo
        async obtenerBoletasPorIndice(){

            this.datosItem.boletasId=0;
            this.boletas=[];
            this.ddBoletasLoading=true;
            await this.$store
            .dispatch(OBTENER_BOLETAS, {idPeriodo: this.datosItem.periodoMedicionId, idIndice: this.indiceSeleccionadoId})
            .then(res => {
                if(res.status===200){
                    this.boletas=res.data;
                } else {
                    console.warn(res.message)
                }
                this.ddBoletasLoading=false;
               
            }
            )
            .catch(() => {
                this.ddBoletasLoading=false;
                //console.warn(err)
            });
        },


        //!Obtener los periodos para la tabla
        obtnenerPeriodosMedicion(){
            this.ddPeriodosLoading = true;
            this.periodos=[];
            
            this.$store
                .dispatch(OBTENER_PERIODOS)
                .then(() => {
                    this.periodos = this.$store.state.periodomedicion.periodos;
                    this.ddPeriodosLoading =false;
                })
                .catch(() => {
                    this.ddPeriodosLoading = false;
                });

        },


    //!Obtener el listado de preguntas por índice
      async obtenerPreguntasPorIndice(){
          this.establecido=true;
          this.tableLoading=true;
          this.preguntas=[];
            await this.$store
            .dispatch(OBTENER_PREGUNTAS_PERIODO_BOLETA_CONFIGURACION, {boletaId:this.datosItem.boletasId, periodoId: this.datosItem.periodoMedicionId})
            .then(res => {
                //console.log(res)
                if(res.status===200){
                    this.preguntas = res.data;
                } else {
                    //console.warn(res.message)
                    this.tableNoDataText = 'No se encontraron preguntas para el índice seleccionado';
                }
                this.tableLoading=false;
            })
            .catch(() => {
                this.tableLoading=false;
                this.tableNoDataText = 'No se encontraron preguntas para el índice seleccionado';
                });

      },


      //!Obtener subpreguntas por id preguntas para asignación
      async obtenerSubPreguntasPorPregunta(PreguntaId, IndiceId){

          this.dialogLoaderVisible=true;
          this.ddSubPreguntasLoading=true;
          this.subpreguntas=[];
            await this.$store
            .dispatch(OBTENER_SUB_PREGUNTAS_POR_PREGUNTA, PreguntaId)
            .then(res => {
               // console.log(res)
                if(res.status===200){
                   

                    //!Asignar las subpreguntas para el dropdown
                    this.subpreguntas = res.data;
                    
                    //!Asignar los datos para el registro
                    this.datosItem.boletasId = this.datosItem.boletasId;
                    this.datosItem.periodoMedicionId= this.datosItem.periodoMedicionId;
                    this.datosItem.indicesId= IndiceId;
                    this.datosItem.noOrdenPregunta= '0';
                    this.datosItem.estadosId= 1;

                    //?Validar si es actualización y asignar los datos
                    
                    if(this.accion===2){
                        this.datosItem.preguntasId = this.datosItem.id;
                        this.datosItem.noOrdenPregunta= this.datosItem.noOrdenPregunta;
                        this.datosItem.estadosId= this.datosItem.estadosId;
                    }
                    

                   

                     console.log(this.datosItem)

                    
                    this.dialogAsingarSub = true;
                } else {
                    //console.warn(res.message)
                    this.$refs.snackalert.SnackbarShow('warning', 'Alerta', res.message);
                    
                }
                this.dialogLoaderVisible=false;
                this.ddSubPreguntasLoading=false;
            })
            .catch(() => {
                this.dialogLoaderVisible=false;
                this.ddSubPreguntasLoading=false;
                this.tableNoDataText = 'No se encontraron preguntas para el índice seleccionado';
            });

          
      },


      //!Obtener las preguntas para asignacion por índice seleccionado
      async obtenerPreguntasPorIndiceParaAsignacion(){
          this.ddPreguntasLoading=true;
          this.preguntasAsignar=[];
            await this.$store
            .dispatch(OBTENER_PREGUNTAS_POR_INDICE, {indiceId:this.indiceSeleccionadoId})
            .then(res => {
                //console.log(res)
                if(res.status===200){
                    this.preguntasAsignar = res.data;
                } else {
                    //console.warn(res.message)
                    this.tableNoDataText = 'No se encontraron preguntas para el índice seleccionado';
                }
                this.ddPreguntasLoading=false;
            })
            .catch(() => {
                this.ddPreguntasLoading=false;
                this.tableNoDataText = 'No se encontraron preguntas para el índice seleccionado';
                });
          
      },


        /*//!Obtener las boletas para la tabla
        obtnenerItems(){
            this.tableLoading = true;
            this.boletas=[];
            
            this.$store
                .dispatch(OBTENER_BOLETAS, 0)
                .then(() => {
                    this.boletas = this.$store.state.boleta.boletas;
                    this.tableLoading =false;
                //console.log(this.etnias)
                })
                .catch(() => {
                    this.tableLoading = false;
                });

        },*/

        /**
         * Obtener los datos de una asignación de pregunta o subpregunta
         * Tipo 1 (Pregunta Principal), Tipo 2 (Sub pregunta)
         * PreguntaPrincipal si viene de una subpregunta, al venir de una pregunta pincipal, su valor es null
         */

        obtenerDatosItem(Id, Tipo, PreguntaPrincipalId){
            this.dialogLoaderVisible=true;
            this.datosItem.id = Id;
            this.accion=2;
            this.modalTitle='Actualizar asignación pregunta';
            this.btnRegistroText='Actualizar';

            this.$store
                .dispatch(OBTENER_PREGUNTA_PERIODO_BOLETA, Id)
                .then(res => {
                   
                    if(res.status===200){
                        this.datosItem = this.$store.state.preguntaperiodoboleta.boleta;

                        this.datosItem.noOrdenPregunta = this.$store.state.preguntaperiodoboleta.boleta.noOrdenPregunta.toString();
                        this.datosItem.estadosId === 1 ? this.switchItemEstado = true : this.switchItemEstado = false;
                        if(this.datosItem.fechaApertura != null) {
                            this.fechas.fechaApertura = moment(this.datosItem.fechaApertura).format('YYYY-MM-DD');
                        }
                        if(this.datosItem.fechaCierre != null) {
                            this.fechas.fechaCierre = moment(this.datosItem.fechaCierre).format('YYYY-MM-DD');
                        }

                        //?Si el tipo es 1 (Pregunta Padre o superior) se muestra el dialog
                        if(Tipo===1)
                            this.dialog = true;

                        //?Si el tipo es 2(Sub pregunta) se muestra el dialog correspondiente
                        else if(Tipo===2){
                        
                            //!Obtener el listado de subpreguntas para mostrar el dialog (modal) 
                            this.obtenerSubPreguntasPorPregunta(PreguntaPrincipalId, 0);
                            

                        }

                    } else {
                        this.$refs.snackalert.SnackbarShow('warning', 'Alerta', res.message);
                    }
                    //console.log(this.datosItem)
                    
                    if(Tipo===1)
                        this.dialogLoaderVisible = false;
                })
                .catch(error => {
                    this.dialogLoaderVisible = false;
                    this.$refs.snackalert.SnackbarShow('warning', 'Alerta', `Ha ocurrido un error, por favor, ponte en contacto con un administrador de sistema. REF: ${error}`);
                });
        },

        registrarItem(){
            //console.log(this.accion)
            
            this.btnRegistroLoading=true;

            this.switchItemEstado ? this.datosItem.estadosId = 1 : this.datosItem.estadosId = 2;

            if(this.accion===1){
                this.datosItem.id = 0;
                this.$store
                    .dispatch(ASIGNAR_PREGUNTA_PERIODO_BOLETA, this.datosItem)
                    .then(res => {
                        //console.log(res)
                        if(res.status===200){
                            this.obtenerPreguntasPorIndice();
                            this.dialog=false;
                            this.$refs.snackalert.SnackbarShow('success', 'Mensaje', res.message);
                            this.resetForm();
                            //this.switchItemEstado = true;
                        } else {
                            this.$refs.snackalert.SnackbarShow('warning', 'Alerta', res.message);
                        }
                        this.btnRegistroLoading=false;
                    })
                    .catch(error => {
                        //console.log(error)
                        this.$refs.snackalert.SnackbarShow('warning', 'Alerta', error);
                        this.btnRegistroLoading=false;
                    });

                        

            } else {
                this.$store
                    .dispatch(ACTUALIZAR_PREGUNTA_PERIODO_BOLETA, this.datosItem)
                    .then(res => {
                        
                        if(res.status===200){
                            this.obtenerPreguntasPorIndice();
                            this.dialog=false;
                            this.$refs.snackalert.SnackbarShow('success', 'Mensaje', res.message);
                            this.resetForm();
                            //this.switchItemEstado = true;
                        } else {
                            this.$refs.snackalert.SnackbarShow('warning', 'Alerta', res.message);
                        }
                        this.btnRegistroLoading=false;
                    })
                    .catch(error => {
                        //console.log(error)
                        this.$refs.snackalert.SnackbarShow('warning', 'Alerta', error);
                        this.btnRegistroLoading=false;
                    });

            }
        }
    },
    mounted() {
        //Definir el nombre en el breadcrumb
        this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Administración", route: "/dashboard" },
            { title: "Boletas" },
            { title: "Configuracion" }
        ]);
    },

    created(){
        this.obtenerIndices();
       // this.obtnenerItems();
        this.obtnenerPeriodosMedicion();
    },

    
    computed: {
        headers() {
            return [
                /*{
                    text: "Id",
                    align: "start",
                    sortable: true,
                    value: "id"
                },*/
                 {
                    text: "Orden",
                    align: "start",
                    sortable: false,
                    value: "noOrden"
                },
                {
                    text: "Preguntas",
                    value: "textoPregunta"
                },
                {
                    text: "Respuestas",
                    value: "respuestas"
                },
                {
                    text: "Medios de Verificación",
                    value: "mediosVerificacionId"
                },
                {
                    text: "Visita de campo",
                    value: "visitaCampo"
                },
                {
                    text: "Estado",
                    value: "estadosId"
                },
                {
                    text: "Acciones",
                    value: "Acciones"
                }
            ]
        },

        //Cambiar el formato de fechas a DD-MM-YYY para mostrar y a YYYY-MM-DD para registrar en datosItem.fechaApertura
        fechaApertura:{
            get: function(){
                return this.fechas.fechaApertura
                ? moment(this.fechas.fechaApertura).format("DD-MM-YYYY")
                : null;
            },
            set: function(val){
                
                this.datosItem.fechaApertura = moment(val, 'DD-MM-YYYY').format('YYYY-MM-DD');
                return val;
            }
        },   
        
        //Cambiar el formato de fechas a DD-MM-YYY para mostrar y a YYYY-MM-DD para registrar en datosItem.fechaCierre
        fechaCierre:{
            get: function(){
                return this.fechas.fechaCierre
                ? moment(this.fechas.fechaCierre).format("DD-MM-YYYY")
                : null;
            },
            set: function(val){
                
                this.datosItem.fechaCierre = moment(val, 'DD-MM-YYYY').format('YYYY-MM-DD');
                return val;
            }
        },   
    },

    watch: {
        
        //Cambiar el formato de fecha de apertura/cierre del objeto datosItem al momento de que fechas.fechaApertura/fechas.fechaCierre cambie
        'fechas.fechaApertura': function(val){
            this.datosItem.fechaApertura = val;
        },

        'fechas.fechaCierre': function(val){
            this.datosItem.fechaCierre = val;
        },

    
    }

    
}
</script>
<style lang="">
    
</style>